import { useState } from 'react';

export function useExerciseGenerators() {
  // Quiz generator
  const [showQuizGenerator, setShowQuizGenerator] = useState(false);
  const [quizInput, setQuizInput] = useState("");
  const [quizLoading, setQuizLoading] = useState(false);
  const [quizLevel, setQuizLevel] = useState('B1');
  const [quizCount, setQuizCount] = useState(6);
  const [generatedQuiz, setGeneratedQuiz] = useState(null);
  const [quizType, setQuizType] = useState('text');

  // ABCD generator
  const [showABCDGenerator, setShowABCDGenerator] = useState(false);
  const [abcdInput, setABCDInput] = useState("");
  const [abcdLevel, setABCDLevel] = useState('B1');
  const [abcdLoading, setABCDLoading] = useState(false);
  const [generatedABCD, setGeneratedABCD] = useState(null);
  const [abcdQuestionCount, setABCDQuestionCount] = useState(5);

  // Open Questions generator
  const [showOpenQuestionsGenerator, setShowOpenQuestionsGenerator] = useState(false);
  const [openQuestionsInput, setOpenQuestionsInput] = useState("");
  const [openQuestionsLevel, setOpenQuestionsLevel] = useState('B1');
  const [openQuestionsLoading, setOpenQuestionsLoading] = useState(false);
  const [generatedOpenQuestions, setGeneratedOpenQuestions] = useState(null);
  const [openQuestionsCount, setOpenQuestionsCount] = useState(6);

  // Word Definition generator
  const [showWordDefinitionGenerator, setShowWordDefinitionGenerator] = useState(false);
  const [wordDefinitionInput, setWordDefinitionInput] = useState("");
  const [wordDefinitionLevel, setWordDefinitionLevel] = useState('B1');
  const [wordDefinitionLoading, setWordDefinitionLoading] = useState(false);
  const [generatedWordDefinitions, setGeneratedWordDefinitions] = useState(null);

  // Word Translation generator
  const [showWordTranslationGenerator, setShowWordTranslationGenerator] = useState(false);
  const [wordTranslationInput, setWordTranslationInput] = useState("");
  const [wordTranslationTargetLanguage, setWordTranslationTargetLanguage] = useState('Russian');
  const [wordTranslationLoading, setWordTranslationLoading] = useState(false);
  const [generatedWordTranslations, setGeneratedWordTranslations] = useState(null);

  // Fill in the Gaps generator
  const [showFillInTheGapsGenerator, setShowFillInTheGapsGenerator] = useState(false);
  const [fillInTheGapsInput, setFillInTheGapsInput] = useState("");
  const [fillInTheGapsLevel, setFillInTheGapsLevel] = useState('B1');
  const [fillInTheGapsLoading, setFillInTheGapsLoading] = useState(false);
  const [generatedFillInTheGaps, setGeneratedFillInTheGaps] = useState(null);
  const [fillInTheGapsMode, setFillInTheGapsMode] = useState('generate');
  const [fillInTheGapsCustomText, setFillInTheGapsCustomText] = useState('');

  // True/False generator
  const [showTrueFalseGenerator, setShowTrueFalseGenerator] = useState(false);
  const [trueFalseInput, setTrueFalseInput] = useState("");
  const [trueFalseLevel, setTrueFalseLevel] = useState('B1');
  const [trueFalseCount, setTrueFalseCount] = useState(5);
  const [trueFalseLoading, setTrueFalseLoading] = useState(false);
  const [generatedTrueFalse, setGeneratedTrueFalse] = useState(null);

  // Warm Up Discussion generator
  const [showWarmUpDiscussionGenerator, setShowWarmUpDiscussionGenerator] = useState(false);
  const [warmUpDiscussionInput, setWarmUpDiscussionInput] = useState("");
  const [warmUpDiscussionLevel, setWarmUpDiscussionLevel] = useState('B1');
  const [warmUpDiscussionCount, setWarmUpDiscussionCount] = useState(5);
  const [warmUpDiscussionLoading, setWarmUpDiscussionLoading] = useState(false);
  const [generatedWarmUpDiscussion, setGeneratedWarmUpDiscussion] = useState(null);

  // Create Dialogue generator
  const [showCreateDialogueGenerator, setShowCreateDialogueGenerator] = useState(false);
  const [createDialogueInput, setCreateDialogueInput] = useState("");
  const [createDialogueLevel, setCreateDialogueLevel] = useState('B1');
  const [createDialogueSpeakers, setCreateDialogueSpeakers] = useState(2);
  const [createDialogueLoading, setCreateDialogueLoading] = useState(false);
  const [generatedCreateDialogue, setGeneratedCreateDialogue] = useState(null);

  // Essential Vocabulary generator
  const [showEssentialVocabularyGenerator, setShowEssentialVocabularyGenerator] = useState(false);
  const [essentialVocabularyMode, setEssentialVocabularyMode] = useState('generate');
  const [essentialVocabularyInput, setEssentialVocabularyInput] = useState("");
  const [essentialVocabularyLevel, setEssentialVocabularyLevel] = useState('B1');
  const [essentialVocabularyPartOfSpeech, setEssentialVocabularyPartOfSpeech] = useState('any');
  const [essentialVocabularyTranslationLanguage, setEssentialVocabularyTranslationLanguage] = useState('none');
  const [essentialVocabularyLoading, setEssentialVocabularyLoading] = useState(false);
  const [generatedEssentialVocabulary, setGeneratedEssentialVocabulary] = useState(null);

  // Lead-in Activities generator
  const [showLeadInActivitiesGenerator, setShowLeadInActivitiesGenerator] = useState(false);
  const [leadInActivitiesInput, setLeadInActivitiesInput] = useState("");
  const [leadInActivitiesLevel, setLeadInActivitiesLevel] = useState('B1');
  const [leadInActivitiesLoading, setLeadInActivitiesLoading] = useState(false);
  const [generatedLeadInActivities, setGeneratedLeadInActivities] = useState(null);

  // Four Opinions generator
  const [showFourOpinionsGenerator, setShowFourOpinionsGenerator] = useState(false);
  const [fourOpinionsInput, setFourOpinionsInput] = useState("");
  const [fourOpinionsLevel, setFourOpinionsLevel] = useState('B1');
  const [fourOpinionsCount, setFourOpinionsCount] = useState(4);
  const [fourOpinionsLoading, setFourOpinionsLoading] = useState(false);
  const [generatedFourOpinions, setGeneratedFourOpinions] = useState(null);

  // Communicative Situations generator
  const [showCommunicativeSituationsGenerator, setShowCommunicativeSituationsGenerator] = useState(false);
  const [communicativeSituationsVocab, setCommunicativeSituationsVocab] = useState("");
  const [communicativeSituationsTopic, setCommunicativeSituationsTopic] = useState("");
  const [communicativeSituationsLevel, setCommunicativeSituationsLevel] = useState('B1');
  const [communicativeSituationsLoading, setCommunicativeSituationsLoading] = useState(false);
  const [generatedCommunicativeSituations, setGeneratedCommunicativeSituations] = useState(null);

  // Matching Halves generator
  const [showMatchingHalvesGenerator, setShowMatchingHalvesGenerator] = useState(false);
  const [matchingHalvesInput, setMatchingHalvesInput] = useState("");
  const [matchingHalvesLevel, setMatchingHalvesLevel] = useState('B1');
  const [matchingHalvesMode, setMatchingHalvesMode] = useState('sentences');
  const [matchingHalvesLoading, setMatchingHalvesLoading] = useState(false);
  const [generatedMatchingHalves, setGeneratedMatchingHalves] = useState(null);

  // Error Correction generator
  const [showErrorCorrectionGenerator, setShowErrorCorrectionGenerator] = useState(false);
  const [errorCorrectionInput, setErrorCorrectionInput] = useState("");
  const [errorCorrectionLevel, setErrorCorrectionLevel] = useState('B1');
  const [errorCorrectionSentenceCount, setErrorCorrectionSentenceCount] = useState('5');
  const [errorCorrectionLoading, setErrorCorrectionLoading] = useState(false);
  const [generatedErrorCorrection, setGeneratedErrorCorrection] = useState(null);

  // Grammar Rules generator
  const [showGrammarRulesGenerator, setShowGrammarRulesGenerator] = useState(false);
  const [grammarRulesInput, setGrammarRulesInput] = useState("");
  const [grammarRulesLevel, setGrammarRulesLevel] = useState('B1');
  const [grammarRulesLanguage, setGrammarRulesLanguage] = useState('English');
  const [grammarRulesLoading, setGrammarRulesLoading] = useState(false);
  const [generatedGrammarRules, setGeneratedGrammarRules] = useState(null);

  // Jumbled Sentence / Word Order generator
  const [showJumbledSentenceGenerator, setShowJumbledSentenceGenerator] = useState(false);
  const [jumbledSentenceInput, setJumbledSentenceInput] = useState('');
  const [jumbledSentenceLevel, setJumbledSentenceLevel] = useState('B1');
  const [jumbledSentenceCount, setJumbledSentenceCount] = useState(5);
  const [jumbledSentenceLoading, setJumbledSentenceLoading] = useState(false);
  const [generatedJumbledSentence, setGeneratedJumbledSentence] = useState(null);
  const [jumbledSentenceMode, setJumbledSentenceMode] = useState('generate');

  // Multiple Choice generator
  const [showMultipleChoiceGenerator, setShowMultipleChoiceGenerator] = useState(false);
  const [multipleChoiceInput, setMultipleChoiceInput] = useState('');
  const [multipleChoiceLevel, setMultipleChoiceLevel] = useState('B1');
  const [multipleChoiceMode, setMultipleChoiceMode] = useState('sentences');
  const [multipleChoiceCount, setMultipleChoiceCount] = useState(5);
  const [multipleChoiceOptionCount, setMultipleChoiceOptionCount] = useState(4);
  const [multipleChoiceLoading, setMultipleChoiceLoading] = useState(false);
  const [generatedMultipleChoice, setGeneratedMultipleChoice] = useState(null);

  // Pros & Cons generator
  const [showProsConsGenerator, setShowProsConsGenerator] = useState(false);
  const [prosConsInput, setProsConsInput] = useState("");
  const [prosConsLevel, setProsConsLevel] = useState("A2");
  const [prosConsPairs, setProsConsPairs] = useState(5);
  const [prosConsLoading, setProsConsLoading] = useState(false);
  const [generatedProsCons, setGeneratedProsCons] = useState(null);

  return {
    // Quiz
    showQuizGenerator, setShowQuizGenerator,
    quizInput, setQuizInput,
    quizLoading, setQuizLoading,
    quizLevel, setQuizLevel,
    quizCount, setQuizCount,
    generatedQuiz, setGeneratedQuiz,
    quizType, setQuizType,
    // ABCD
    showABCDGenerator, setShowABCDGenerator,
    abcdInput, setABCDInput,
    abcdLevel, setABCDLevel,
    abcdLoading, setABCDLoading,
    generatedABCD, setGeneratedABCD,
    abcdQuestionCount, setABCDQuestionCount,
    // Open Questions
    showOpenQuestionsGenerator, setShowOpenQuestionsGenerator,
    openQuestionsInput, setOpenQuestionsInput,
    openQuestionsLevel, setOpenQuestionsLevel,
    openQuestionsLoading, setOpenQuestionsLoading,
    generatedOpenQuestions, setGeneratedOpenQuestions,
    openQuestionsCount, setOpenQuestionsCount,
    // Word Definition
    showWordDefinitionGenerator, setShowWordDefinitionGenerator,
    wordDefinitionInput, setWordDefinitionInput,
    wordDefinitionLevel, setWordDefinitionLevel,
    wordDefinitionLoading, setWordDefinitionLoading,
    generatedWordDefinitions, setGeneratedWordDefinitions,
    // Word Translation
    showWordTranslationGenerator, setShowWordTranslationGenerator,
    wordTranslationInput, setWordTranslationInput,
    wordTranslationTargetLanguage, setWordTranslationTargetLanguage,
    wordTranslationLoading, setWordTranslationLoading,
    generatedWordTranslations, setGeneratedWordTranslations,
    // Fill in the Gaps
    showFillInTheGapsGenerator, setShowFillInTheGapsGenerator,
    fillInTheGapsInput, setFillInTheGapsInput,
    fillInTheGapsLevel, setFillInTheGapsLevel,
    fillInTheGapsLoading, setFillInTheGapsLoading,
    generatedFillInTheGaps, setGeneratedFillInTheGaps,
    fillInTheGapsMode, setFillInTheGapsMode,
    fillInTheGapsCustomText, setFillInTheGapsCustomText,
    // True/False
    showTrueFalseGenerator, setShowTrueFalseGenerator,
    trueFalseInput, setTrueFalseInput,
    trueFalseLevel, setTrueFalseLevel,
    trueFalseCount, setTrueFalseCount,
    trueFalseLoading, setTrueFalseLoading,
    generatedTrueFalse, setGeneratedTrueFalse,
    // Warm Up Discussion
    showWarmUpDiscussionGenerator, setShowWarmUpDiscussionGenerator,
    warmUpDiscussionInput, setWarmUpDiscussionInput,
    warmUpDiscussionLevel, setWarmUpDiscussionLevel,
    warmUpDiscussionCount, setWarmUpDiscussionCount,
    warmUpDiscussionLoading, setWarmUpDiscussionLoading,
    generatedWarmUpDiscussion, setGeneratedWarmUpDiscussion,
    // Create Dialogue
    showCreateDialogueGenerator, setShowCreateDialogueGenerator,
    createDialogueInput, setCreateDialogueInput,
    createDialogueLevel, setCreateDialogueLevel,
    createDialogueSpeakers, setCreateDialogueSpeakers,
    createDialogueLoading, setCreateDialogueLoading,
    generatedCreateDialogue, setGeneratedCreateDialogue,
    // Essential Vocabulary
    showEssentialVocabularyGenerator, setShowEssentialVocabularyGenerator,
    essentialVocabularyMode, setEssentialVocabularyMode,
    essentialVocabularyInput, setEssentialVocabularyInput,
    essentialVocabularyLevel, setEssentialVocabularyLevel,
    essentialVocabularyPartOfSpeech, setEssentialVocabularyPartOfSpeech,
    essentialVocabularyTranslationLanguage, setEssentialVocabularyTranslationLanguage,
    essentialVocabularyLoading, setEssentialVocabularyLoading,
    generatedEssentialVocabulary, setGeneratedEssentialVocabulary,
    // Lead-in Activities
    showLeadInActivitiesGenerator, setShowLeadInActivitiesGenerator,
    leadInActivitiesInput, setLeadInActivitiesInput,
    leadInActivitiesLevel, setLeadInActivitiesLevel,
    leadInActivitiesLoading, setLeadInActivitiesLoading,
    generatedLeadInActivities, setGeneratedLeadInActivities,
    // Four Opinions
    showFourOpinionsGenerator, setShowFourOpinionsGenerator,
    fourOpinionsInput, setFourOpinionsInput,
    fourOpinionsLevel, setFourOpinionsLevel,
    fourOpinionsCount, setFourOpinionsCount,
    fourOpinionsLoading, setFourOpinionsLoading,
    generatedFourOpinions, setGeneratedFourOpinions,
    // Communicative Situations
    showCommunicativeSituationsGenerator, setShowCommunicativeSituationsGenerator,
    communicativeSituationsVocab, setCommunicativeSituationsVocab,
    communicativeSituationsTopic, setCommunicativeSituationsTopic,
    communicativeSituationsLevel, setCommunicativeSituationsLevel,
    communicativeSituationsLoading, setCommunicativeSituationsLoading,
    generatedCommunicativeSituations, setGeneratedCommunicativeSituations,
    // Matching Halves
    showMatchingHalvesGenerator, setShowMatchingHalvesGenerator,
    matchingHalvesInput, setMatchingHalvesInput,
    matchingHalvesLevel, setMatchingHalvesLevel,
    matchingHalvesMode, setMatchingHalvesMode,
    matchingHalvesLoading, setMatchingHalvesLoading,
    generatedMatchingHalves, setGeneratedMatchingHalves,
    // Error Correction
    showErrorCorrectionGenerator, setShowErrorCorrectionGenerator,
    errorCorrectionInput, setErrorCorrectionInput,
    errorCorrectionLevel, setErrorCorrectionLevel,
    errorCorrectionSentenceCount, setErrorCorrectionSentenceCount,
    errorCorrectionLoading, setErrorCorrectionLoading,
    generatedErrorCorrection, setGeneratedErrorCorrection,
    // Grammar Rules
    showGrammarRulesGenerator, setShowGrammarRulesGenerator,
    grammarRulesInput, setGrammarRulesInput,
    grammarRulesLevel, setGrammarRulesLevel,
    grammarRulesLanguage, setGrammarRulesLanguage,
    grammarRulesLoading, setGrammarRulesLoading,
    generatedGrammarRules, setGeneratedGrammarRules,
    // Jumbled Sentence
    showJumbledSentenceGenerator, setShowJumbledSentenceGenerator,
    jumbledSentenceInput, setJumbledSentenceInput,
    jumbledSentenceLevel, setJumbledSentenceLevel,
    jumbledSentenceCount, setJumbledSentenceCount,
    jumbledSentenceLoading, setJumbledSentenceLoading,
    generatedJumbledSentence, setGeneratedJumbledSentence,
    jumbledSentenceMode, setJumbledSentenceMode,
    // Multiple Choice
    showMultipleChoiceGenerator, setShowMultipleChoiceGenerator,
    multipleChoiceInput, setMultipleChoiceInput,
    multipleChoiceLevel, setMultipleChoiceLevel,
    multipleChoiceMode, setMultipleChoiceMode,
    multipleChoiceCount, setMultipleChoiceCount,
    multipleChoiceOptionCount, setMultipleChoiceOptionCount,
    multipleChoiceLoading, setMultipleChoiceLoading,
    generatedMultipleChoice, setGeneratedMultipleChoice,
    // Pros & Cons
    showProsConsGenerator, setShowProsConsGenerator,
    prosConsInput, setProsConsInput,
    prosConsLevel, setProsConsLevel,
    prosConsPairs, setProsConsPairs,
    prosConsLoading, setProsConsLoading,
    generatedProsCons, setGeneratedProsCons,
  };
}
